import { memo } from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';

import { ThemeSwitcher } from '@/components/theme';

import styles from './Header.module.scss';

export const Header = memo(function Header() {
  const location = useLocation();

  return (
    <Navbar variant="dark" expand="lg" className={styles.header}>
      <Container fluid>
        <Navbar.Brand as={Link} to="/" className={styles.brand}>
          <span className={styles.brandIcon}>
            <i className="bi bi-building" />
          </span>
          Datex
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="main-navbar" />
        <Navbar.Collapse id="main-navbar">
          <Nav className="me-auto">
            <Nav.Link
              as={Link}
              to="/"
              active={location.pathname === '/'}
              className={styles.navLink}
            >
              Facilities
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/organizations"
              active={location.pathname === '/organizations'}
              className={styles.navLink}
            >
              Organizations
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/map"
              active={location.pathname === '/map'}
              className={styles.navLink}
            >
              Map
            </Nav.Link>
          </Nav>
          <Nav className="align-items-center">
            <Navbar.Text className={`${styles.tagline} d-none d-md-block me-3`}>
              Canadian Childcare Data Explorer
            </Navbar.Text>
            <ThemeSwitcher />
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
});
